<template>
  <div class="tableContainer">
    <!-- <div class="filterButtonPosition" style="right: 64px"> -->
    <!-- <f7-button
        fill
        class="whiteFontColor button-filter"
        panel-toggle="right"
      >
        <span class="ic-filter"></span> {{ $t('filter') }}
      </f7-button> -->
    <!-- </div> -->
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid custom-grid-detail-healthSecurity"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
      @content-ready="init"
    >
      <DxExport :enabled="true" />
      <DxScrolling mode="standard" />

      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="healthSecuritySamplesDetailTable_v2"
      />
      <DxSelection mode="single" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="cma_is_apt"
        caption=""
        header-cell-template="cellTemplateHeaderDots"
        :width="35"
        :allow-sorting="false"
        cell-template="cellTemplateDots"
      />
      <template #cellTemplateDots="{ data }">
        <div class="dots-parent-container">
          <img width="20" height="20" :src="getDotColorImage(data)" />
        </div>
      </template>
      <DxColumn
        data-field="parameter_group"
        :caption="$t('group')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parameter"
        :caption="$t('foodSamples.parameter')"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="result_value"
        :caption="$t('foodSamples.result')"
        cell-template="cellTemplateResultadoPresentacion"
        :calculate-cell-value="calculateResultValue"
        :allow-header-filtering="false"
      />

      <template #cellTemplateResultadoPresentacion="{ data }">
        <div>
          {{
            data.data.value.ResultadoPresentacion.includes(
              'En Proceso'
            )
              ? $t('inProcess')
              : data.data.value.ResultadoPresentacion
          }}
        </div>
      </template>

      <DxColumn
        data-field="unit_value"
        :caption="$t('foodSamples.unit')"
        :calculate-cell-value="calculateUnitValue"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="range_value"
        :caption="$t('foodSamples.range')"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateRange"
      />

      <DxColumn
        data-field="specification_value"
        :caption="$t('healthSecurity.specification')"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateSpecification"
      />

      <template #cellTemplateHeaderDots="{ data }">
        <div>
          <PopUp position="top">
            <div style="padding: 10px">
              <div class="pop-up-info">
                <img
                  :src="getDotImage('grey')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{ $t('healthSecurity.detail.greyDotDescription') }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('green')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('healthSecurity.detail.greenDotDescription')
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('red')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{ $t('healthSecurity.detail.redDotDescription') }}
                </div>
              </div>
            </div>
          </PopUp>
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
  DxSelection,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import PopUp from '@/components/UtilityComponents/popUpInfo/popUp.vue';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
    DxSelection,
    DxSearchPanel,
    PopUp,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('samples', ['reportSampleCode']),
  },
  methods: {
    getDotImage(color) {
      return require(`../../../../../assets/dot-colors/${color}_new.svg`)
        .default;
    },
    getDotColorImage(data) {
      if (!data.value && data.value !== false) {
        return require(`../../../../../assets/dot-colors/grey_new.svg`)
          .default;
      }
      if (data.value === false) {
        return require(`../../../../../assets/dot-colors/red_new.svg`)
          .default;
      }
      return require(`../../../../../assets/dot-colors/green_new.svg`)
        .default;
    },
    calculateRange(rowData) {
      return `${rowData.value.r_min} - ${rowData.value.r_max}`;
    },
    calculateUnitValue(rowData) {
      return rowData?.value?.unit ?? '';
    },
    calculateResultValue(rowData) {
      return rowData?.value?.ResultadoPresentacion ?? '';
    },
    calculateSpecification(rowData) {
      return rowData.value?.pharma?.[0]?.especification ?? '';
    },
    init(e) {
      this.setSampleDetails(e.component.getDataSource().items());
    },
    onExporting(e) {
      e.component.beginUpdate();
      e.component.columnOption('ID', 'visible', true);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(
        this.$t('healthSecurity.exportExcelName')
      );

      exportDataGrid({
        component: e.component,
        worksheet,
      })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], {
                type: 'application/octet-stream',
              }),
              `besafer-${this.reportSampleCode}.xlsx`
            );
          });
        })
        .then(() => {
          e.component.columnOption('ID', 'visible', false);
          e.component.endUpdate();
        });

      e.cancel = true;
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;

      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'after';
        }
        if (item.name === 'exportButton') {
          item.location = 'after';
        }

        // if (item.name === 'groupPanel') {
        //   item.location = 'after';
        // }
      });
      toolbarItems.push({
        name: 'Filtros',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: '',
          icon: '././static/icons/ic_filter.svg',
          width: 40,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    ...mapActions('healthSecuritySamples', ['setSampleDetails']),
  },
};
</script>

<style>
/* ::v-deep .dx-toolbar-after {
  left: initial !important;
  padding-top: 6px;
  padding-bottom: 6px;
} */

/* ::v-deep .dx-datagrid-header-panel .dx-toolbar {
  padding-top: 16px;
  padding-bottom: 16px;
} */

/* ::v-deep .dx-btn-filtro {
  background-color: #00346a;
  border-radius: 10px;
  padding-left: 34px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-left: 16px;
  min-width: 80px;
  font-weight: bold;
  font-size: 14px;
  color: white;
  border: none;
  display: inline-block;
  position: relative;
  cursor: pointer;
  right: 15px;
} */

/* ::v-deep .dx-btn-filtro .icon-filter {
  background-image: url('@/static/Navbar/icons/ic_filter.svg');
  background-repeat: no-repeat;
  background-size: contain;
  width: 26px;
  height: 26px;
  position: absolute;
  left: 12px;
  top: 4px;
} */
/* .custom-grid-detail-healthSecurity .dx-toolbar-after {
  display: grid;
  grid-template-columns: 123px 120px 43px 40px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
  justify-self: end;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after :nth-child(3) {
  grid-row: 1;
  grid-column: 3;
} */
.custom-grid-detail-healthSecurity .dx-searchbox {
  width: 200px !important;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after {
  display: grid;
  grid-template-columns: 107px 98px 49px 37px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-detail-healthSecurity .dx-toolbar-after :nth-child(3) {
  grid-row: 1;
  grid-column: 3;
  justify-self: start;
}
/* Input más grande */
.custom-grid-detail-healthSecurity
  .dx-searchbox
  .dx-texteditor-input {
  padding-left: 36px !important;
  height: 40px !important;
  line-height: 40px !important;
}

/* Contenedor */
.custom-grid-detail-healthSecurity .dx-searchbox {
  position: relative;
  height: 40px !important;
}

/* ICONO */
.custom-grid-detail-healthSecurity .dx-searchbox::before {
  content: '';
  position: absolute;

  left: 7px;
  top: 45%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;

  background-image: url('@/static/icons/ic_search_blue.svg');
  background-repeat: no-repeat;
  background-size: 24px 24px;

  pointer-events: none;
}
</style>
